/** Componente media care rezolvă URL-uri semnate (fileId → URL → rescris prin /media). */
import { useQuery } from '@tanstack/react-query';
import { getFileUrl } from '../api/endpoints';
import { resolveMediaUrl } from '../lib/media';
import { Skeleton } from './ui';

export function MediaImage({ fileId, alt, style }: { fileId: string; alt?: string; style?: React.CSSProperties }) {
  const { data } = useQuery({ queryKey: ['file-url', fileId], queryFn: () => getFileUrl(fileId), staleTime: 240_000 });
  const url = resolveMediaUrl(data?.url);
  if (!url) return <Skeleton height="100%" style={{ borderRadius: 8, ...style }} />;
  return <img src={url} alt={alt ?? ''} style={{ objectFit: 'cover', width: '100%', height: '100%', ...style }} />;
}

export function MediaVideo({ url, poster, style }: { url: string | null | undefined; poster?: string; style?: React.CSSProperties }) {
  const src = resolveMediaUrl(url);
  if (!src) return null;
  return (
    <video src={src} poster={poster} controls playsInline style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 20, ...style }} />
  );
}
